import { Brand } from "../../../../types";
import { colors } from "@storeblocks/global-styles";
import { getBranding } from "../../../../Themes/allThemes";
import styled from "styled-components";
export const Circle = styled.div `
  background-color: ${(props) => {
    if (props.complete && props.branding === Brand.DEFAULT) {
        return "transparent";
    }
    if (!props.active && props.branding === Brand.DEFAULT) {
        return colors.grey.grey40;
    }
    return props.active
        ? getBranding(props.branding).circle.backgroundColorActive
        : getBranding(props.branding).circle.backgroundColor;
}};
  border: ${(props) => props.complete && props.branding === Brand.DEFAULT
    ? `1px solid ${colors.aqua.aqua70}`
    : ""};
  border-radius: 50%;
  height: 32px;
  padding: 16px;
  position: relative;
  width: 32px;
  margin-bottom: 8px;
`;
export const CircleContent = styled.div `
  font-weight: 600;
  left: 50%;
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  div {
    color: ${(props) => props.active
    ? getBranding(props.branding).circle.textColorActive
    : getBranding(props.branding).circle.textColor};
    font-weight: 600;
  }
`;
//# sourceMappingURL=styled.js.map